module.exports = __webpack_public_path__ + "img/playersGroup_w.1f960f7c.svg";